import Promise from 'bluebird';

export const getGenericImageObjectAsync = (genericImageSource) => {
  const nativeImageObject = new Image();

  let resolver = null;

  const getImagePromise = new Promise((resolve) => {
    resolver = resolve;
  });

  nativeImageObject.onload = () => {
    resolver({
      Src: nativeImageObject.src,
      Width: nativeImageObject.naturalWidth,
      Height: nativeImageObject.naturalHeight,
      Type: 'Image191x100',
    });
  };

  nativeImageObject.src = genericImageSource;

  return getImagePromise;
};
